import { render } from "./KubernetesTroubleshooting.vue?vue&type=template&id=627c7509"
import script from "./KubernetesTroubleshooting.vue?vue&type=script&lang=js"
export * from "./KubernetesTroubleshooting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__